import { Component } from '@verndale/core';
import { nanoid } from 'nanoid';

import { getHash } from '../utils/url';
import keys from '../utils/keys';

class Accordion extends Component {
  setupDefaults() {
    this.dom = {
      $accordion: this.el._$('.accordion__accordion'),
      $buttons: this.el._$$('.accordion__tab-heading-button'),
      $blocks: this.el._$$('.accordion__block')
    };

    this.setAdditionalAttributes();
    this.detectHash();
    this.detectDesktopImage();
  }

  addListeners() {
    const { $accordion } = this.dom;

    $accordion._on('click', ::this.handleClick);
    $accordion._on('keydown', ::this.handleKeydown);
  }

  handleClick(e) {
    const $button = e.target.closest('.accordion__tab-heading-button');

    if ($button) {
      const $heading = $button.parentNode;
      const isOpen = $button.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        $heading.classList.add('accordion__tab-heading--closed');
        $button.setAttribute('aria-expanded', 'false');
      } else {
        $heading.classList.remove('accordion__tab-heading--closed');
        $button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  handleKeydown(e) {
    const { $buttons } = this.dom;
    const { activeElement } = document;
    const isButtonActive = activeElement.matches(
      '.accordion__tab-heading-button'
    );
    const currentButtonIndex = () =>
      $buttons.findIndex((button) => button === activeElement);
    const { length } = $buttons;

    switch (e.keyCode) {
      case keys.home:
        e.preventDefault();
        $buttons[0].focus();
        break;
      case keys.end:
        e.preventDefault();
        $buttons[length - 1].focus();
        break;
      case keys.up:
        e.preventDefault();
        if (isButtonActive) {
          $buttons[(currentButtonIndex() - 1 + length) % length].focus();
        }
        break;
      case keys.down:
        e.preventDefault();
        if (isButtonActive) {
          $buttons[(currentButtonIndex() + 1) % length].focus();
        }
        break;
      default:
        break;
    }
  }

  setAdditionalAttributes() {
    const { $buttons } = this.dom;

    $buttons.forEach((button) => {
      const buttonId = `id-${nanoid()}`;
      const sectionContentId = `id-${nanoid()}`;
      const $heading = button.parentNode;
      const $sectionContent = $heading.nextElementSibling;

      button.id = buttonId;
      button.setAttribute('aria-controls', sectionContentId);
      $sectionContent.setAttribute('role', 'region');
      $sectionContent.id = sectionContentId;
      $sectionContent.setAttribute('aria-labelledby', buttonId);

      if ($heading.dataset.openByDefault === 'true') {
        button.setAttribute('aria-expanded', 'true');
      } else {
        $heading.classList.add('accordion__tab-heading--closed');
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }

  detectHash() {
    const { $blocks } = this.dom;
    const url = window.location.href;
    const hash = getHash(url);
    const $targetBlock = $blocks.find(
      (block) => block.id === hash.replace('#', '')
    );

    if ($targetBlock) {
      const $targetHeading = $targetBlock._$('.accordion__tab-heading');
      const $targetButton = $targetBlock._$('.accordion__tab-heading-button');

      if (
        $targetHeading.dataset.openByDefault === 'true' ||
        $targetHeading.dataset.openAnchor === 'true'
      ) {
        $targetHeading.classList.remove('accordion__tab-heading--closed');
        $targetButton.setAttribute('aria-expanded', 'true');
      }
    }
  }

  detectDesktopImage() {
    const $desktopImages = this.el._$$('.accordion__image--desktop');

    $desktopImages.forEach(($image) => {
      const $wrapper = $image.previousElementSibling;

      if (
        $wrapper &&
        $wrapper.classList.contains('accordion__tab-content-wrapper')
      ) {
        $wrapper.classList.add(
          'accordion__tab-content-wrapper--with-desktop-image'
        );
      }
    });
  }
}

export default Accordion;
